import type { OrderExportForm } from "../types/orderExportTypes";

export const validateOrderExport = (form: OrderExportForm) => {
  const start = new Date(`${form.fromDate}T${form.fromTime}`);
  const end = new Date(`${form.toDate}T${form.toTime}`);
  return {
    account: Boolean(form.account), warehouse: form.warehouse.length > 0,
    status: form.status.length > 0, fileType: Boolean(form.fileType),
    template: Boolean(form.templateUrl), dates: Boolean(form.fromDate && form.toDate && form.fromTime && form.toTime),
    range: end >= start,
  };
};
